import { RiskMatrixCell } from '../admin/risk-matrices/risk-matrix-cell';

export class RiskMatrixSelection {
  riskMatrixId: string;
  riskMatrixCell: RiskMatrixCell;
}
